import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50/80">
      <div className="max-w-[1280px] mx-auto px-6 md:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="text-background-50 font-heading text-xl font-bold whitespace-nowrap cursor-pointer">
              Hoobuy Spreadsheet
            </Link>
            <p className="mt-4 text-sm text-background-50/60 leading-relaxed max-w-xs">
              O maior hub de planilhas organizadas com os melhores produtos premium para compras internacionais.
            </p>
          </div>

          {/* Links Column 1 */}
          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">Primeiros Passos</h4>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Acessar Planilha</a></li>
              <li><Link to="/guia/artigo-hoobuy-spreadsheet" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Guia Completo</Link></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Ver Categorias</a></li>
            </ul>
          </div>

          {/* Links Column 2 */}
          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">Informações</h4>
            <ul className="space-y-2.5">
              <li><Link to="/guia/artigo-hoobuy-spreadsheet" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">O que é Hoobuy</Link></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Produtos</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Comprar Agora</a></li>
            </ul>
          </div>

          {/* Links Column 3 */}
          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">Links Úteis</h4>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">hoobuy sheet</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">buy it now</a></li>
              <li><Link to="/guia/artigo-hoobuy-spreadsheet" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Guia 2026</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-14 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/50">
            &copy; Hoobuy Spreadsheet 2026. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap cursor-pointer">Privacidade</Link>
            <Link to="/" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap cursor-pointer">Termos</Link>
            <Link to="/guia/artigo-hoobuy-spreadsheet" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap cursor-pointer">Blog</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}